/**
 * Traducciones del reloj de recompra (membresía): la pantalla grande,
 * la tarjeta del resumen y su configuración en el plan.
 *
 * Las CLAVES son el texto en español, tal cual se escribió en el
 * componente. Ver la nota de `shop.ts`.
 */
export const membershipEn: Record<string, string> = {
  "Reloj de recompra": "Repurchase clock",
  "Tu ciclo de membresía: cada pedido validado lo reinicia.":
    "Your membership cycle: every validated order restarts it.",
  "Cuenta regresiva": "Countdown",
  "Recompra · próximo ciclo": "Repurchase · next cycle",
  días: "days",
  "Te quedan {{days}} días, {{hours}}h {{minutes}}m {{seconds}}s para tu próxima recompra.":
    "You have {{days}} days, {{hours}}h {{minutes}}m {{seconds}}s left until your next repurchase.",
  "Hacer mi primera compra": "Make my first purchase",
  "Hacer recompra": "Repurchase now",
  "Inicio del ciclo": "Cycle start",
  "Pedido {{folio}}": "Order {{folio}}",
  "Próxima fecha de recompra": "Next repurchase date",
  "Ciclo de {{n}} días": "{{n}}-day cycle",
  "Estado de la membresía": "Membership status",
  "Aviso {{n}} días antes de vencer": "Warning {{n}} days before it expires",
  "Tu paquete actual": "Your current package",
  "Ver paquetes": "See packages",
  "Validado el {{date}}": "Validated on {{date}}",
  "Aún no tienes paquetes. Tu primer pedido validado arranca tu ciclo de recompra.":
    "You don't have a package yet. Your first validated order starts your repurchase cycle.",
  "Mantén tu nivel activo": "Keep your level active",
  "Cada pedido validado reinicia tu ciclo de {{n}} días. Mientras tu membresía esté activa, tus invitados y tus puntos cuentan para tu rango; si vence, dejas de acumular hasta que recompres.":
    "Every validated order restarts your {{n}}-day cycle. While your membership is active, your invitees and points count toward your rank; if it expires, you stop accumulating until you repurchase.",
  "Ver mi reloj": "See my clock",

  // Estados (MEMBERSHIP_STATUS_LABELS) y sus frases
  "Sin membresía": "No membership",
  Activa: "Active",
  "Por vencer": "Expiring soon",
  Vencida: "Expired",
  "Aún no tienes una primera compra validada. Tu primer pedido arranca el ciclo.":
    "You don't have a validated first purchase yet. Your first order starts the cycle.",
  "Tu membresía está activa.": "Your membership is active.",
  "Tu membresía está por vencer. Haz tu recompra para no perder tu posición.":
    "Your membership is about to expire. Repurchase so you don't lose your position.",
  "Tu membresía venció. Recompra para reiniciar el ciclo.":
    "Your membership expired. Repurchase to restart the cycle.",

  // El bloque del resumen: paquete · autoship y sus cards
  "Mi paquete · Autoship": "My package · Autoship",
  "Mis paquetes · Autoship": "My packages · Autoship",
  "{{n}} productos": "{{n}} products",
  "{{n}} unidades": "{{n}} units",
  "{{n}} productos · {{u}} unidades": "{{n}} products · {{u}} units",
  "Próximo restock": "Next restock",
  "Tu ciclo venció el {{date}}. Haz tu recompra para reiniciarlo.":
    "Your cycle expired on {{date}}. Repurchase to restart it.",
  "Sin ciclo activo": "No active cycle",
  "Paquetes adquiridos": "Acquired packages",
  "Todavía no has adquirido paquetes.": "You haven't acquired any packages yet.",
  Mayorista: "Wholesale",
  Personal: "Personal",
  "Personalizar paquete": "Customize package",
  Ver: "See",
  "Comisiones disponibles": "Available commissions",
  "Pesos mexicanos · devengado, por liberar": "Mexican pesos · earned, pending release",
  "Dólares · devengado, por liberar": "US dollars · earned, pending release",
  "Solicitar retiro": "Request withdrawal",
  "Los retiros se habilitan con la liberación de comisiones": "Withdrawals open once commissions are released",
  "Los retiros se habilitan con la liberación de comisiones.": "Withdrawals open once commissions are released.",
  "Tu nivel": "Your level",
  Categoría: "Category",
  "Rango {{rank}}": "Rank {{rank}}",
  "Ver progreso": "See progress",
  "Reloj de comisiones": "Commission clock",
  "Próximo corte: {{date}}": "Next cutoff: {{date}}",
  "Avance del periodo": "Period progress",

  // Configuración en el plan (admin)
  "Ciclo de recompra (días)": "Repurchase cycle (days)",
  "Aviso «por vencer» (días antes)": "“Expiring soon” warning (days before)",
  "Cada pedido validado reinicia el reloj del comprador con este ciclo. Aplica a las validaciones nuevas.":
    "Every validated order restarts the buyer's clock with this cycle. Applies to new validations.",
  "El ciclo va de 1 a 365 días": "The cycle goes from 1 to 365 days",
  "El aviso tiene que ser más corto que el ciclo": "The warning must be shorter than the cycle",
  // ── La membresía ANUAL (14-sep-2026) ─────────────────────────────
  "Membresía anual": "Annual membership",
  "Activar mi membresía": "Activate my membership",
  "Renovar mi membresía": "Renew my membership",
  "Tu membresía anual es la que te da acceso a cobrar las comisiones de tu red. Se paga cada año: cualquier membresía o paquete la renueva por 12 meses más.":
    "Your annual membership is what lets you earn the commissions of your network. It is paid every year: any membership or package renews it for 12 more months.",
  "Vence el": "Expires on",
  "Días restantes": "Days left",
  Desde: "Since",
  "Compraste tu membresía": "You bought your membership",
  "Te la regaló tu paquete": "Your package included it",
  "Vino con tu franquicia": "It came with your franchise",
  "La activó el equipo": "Activated by the team",
  "Renueva antes de que venza para no dejar de cobrar": "Renew before it expires so you keep earning",
  "Mientras no renueves, no cobras comisiones": "Until you renew, you earn no commissions",
  "Membresía anual vencida · renuévala para cobrar": "Annual membership expired · renew it to earn",
  "Sin membresía anual · actívala para cobrar": "No annual membership · activate it to earn",
};
